<template>
    <div class="w-full widget-time-absolute">
        <date-time-picker
            :date="fetchDate"
            :picker-options="pickerOptions"
            :range-separator="rangeSeparator"
            :clearable="false"
            size="small"
            @on-change="onChange"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WidgetTime } from '@/types/dashboard'
import DateTimePicker from '@/components/Common/DateTimePicker.vue'
import { useVModel } from '@vueuse/core'
import get from 'lodash/get'
import { TIME_LINE_TIMESTAMP } from '@/enum/generic'
import { dayjs } from '@/composables/useDayjs'

const props = defineProps<{
    value: WidgetTime
    widgetTimeOptions?: Array<Record<string, string>>
    rangeSeparator?: string
}>()

const emit = defineEmits([ 'input' ])

const model = useVModel(props, 'value', emit, { eventName: 'input' })

const pickerOptions = {
    disabledDate (time: Date) {
        const date = new Date()
        const dateAfterNineteenDays = date.setDate(date.getDate() + 90)
        return time.getTime() > dateAfterNineteenDays
    }
}

const fetchDate = computed(() => {
    let newDate = new Date()
    const widgetTime = model.value

    const startDate = newDate.setDate(newDate.getDate() - parseInt(widgetTime.Date_interval || '0'))

    newDate = new Date()
    const endDate = newDate.setDate(newDate.getDate() + (-parseInt(widgetTime.Date_interval || '0') + parseInt(widgetTime.datedeff || '0')))

    return [ startDate, endDate ]
})

function onChange (dates: Array<Date>) {
    const dateStart = get(dates, '[0]')
    const dateEnd = get(dates, '[1]')

    const Difference_In_Time = dateEnd.getTime() - dateStart.getTime()

    model.value.datedeff = (Difference_In_Time / TIME_LINE_TIMESTAMP.DAY).toString()

    const _Difference_In_Time = new Date().getTime() - dateStart.getTime()
    model.value.Date_interval = (_Difference_In_Time / TIME_LINE_TIMESTAMP.DAY).toString()

    model.value['Date_start'] = dayjs(new Date(dateStart)).format('YYYY-MM-DD')
    model.value['Date_end'] = dayjs(new Date(dateEnd)).format('YYYY-MM-DD')
}
</script>

